import { Avatar, Box, styled, Typography } from "@mui/material";

import { baseUrl } from "../../../shared/config";
import { useNavigate } from "react-router-dom";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  ".userTitle_secondaryText": {
    color: theme.palette.text.secondary,
    fontSize: "11px",
  },
}));

export default function UserTitle({ userData, secondary, sx = {} }) {
  const navigate = useNavigate();

  const handleClickProfile = () => {
    navigate("../social/perfil/" + userData.studentId || "0");
  };
  return (
    <Wrapper sx={{ ...sx }}>
      <Avatar src={`${baseUrl}/membros/fotos/${userData?.pictureURL}`} />
      <span>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: "600", cursor: "pointer" }}
          onClick={handleClickProfile}
        >
          {userData?.name}
        </Typography>
        {secondary && (
          <Typography className="userTitle_secondaryText">
            {secondary}
          </Typography>
        )}
      </span>
    </Wrapper>
  );
}
